__turbopack_context__.v({
  "container": "-W3jsG_container",
  "isSelected": "-W3jsG_isSelected",
  "item": "-W3jsG_item",
  "list": "-W3jsG_list",
  "variant--bold": "-W3jsG_variant--bold",
});
